import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { ToastrModule } from 'ngx-toastr';
import { VikRoutingModule } from './vik-routing.module';
import { WorkingGroupComponent } from './components/workingGroups/workingGroup.component';
import { WorkingGroupsCreationComponent } from './components/workingGroups/workingGroups-creation/workingGroups-creation.component';
import { WorkingGroupEditComponent } from './components/workingGroups/workingGroups-edit/workingGroups-edit.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AdminModule } from "../admin/admin.module";
import { SharedModule } from 'src/app/shared/shared.module';
import { NgxDropzoneModule } from 'ngx-dropzone';
import { SignalsRegistrationListComponent } from './components/signals-registration-list/signals-registration-list.component';
import { AddSignalRegistrationComponent } from './components/modals/add-signal-registration/add-signalRegistration.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { UnitsComponent } from './components/nomenclatures/units/units.component';
import { UnitCreationComponent } from './components/nomenclatures/units/units-creation/units-creation.component';
import { UnitEditComponent } from './components/nomenclatures/units/units-edit/units-edit.component';
import { MaterialEditComponent } from './components/materials/materials-edit/materials-edit.component';
import { MaterialsCreationComponent } from './components/materials/materials-creation/materials-creation.component';
import { MaterialsComponent } from './components/materials/materials.component';
import { SignalsMapViewComponent } from './components/signals-registration-list/signals-map-view/signals-map-view.component';
import { EmergenciesListComponent } from './components/emergencies-list/emergencies-list.component';
import { AddEmergencyComponent } from './components/modals/add-emergency/add-emergency.component';
import { EmergenciesMapViewComponent } from './components/emergencies-list/emergencies-map-view/emergencies-map-view.component';
import { SignalFilterFormComponent } from './components/signals-registration-list/signal-filter-form/signal-filter-form.component';
import { MechanisationComponent } from './components/mechanisation/mechanisation.component';
import { MechanisationCreationComponent } from './components/mechanisation/mechanisation-creation/mechanisation-creation.component';
import { MechanisationEditComponent } from './components/mechanisation/mechanisation-edit/mechanisation-edit.component';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input-gg';
import { EmergencyFilterFormComponent } from './components/emergencies-list/emergency-filter-form/emergency-filter-form.component';
import { EmergencyMaterialsFormSelectComponent } from './components/emergencies-list/emergency-materials-form-select/emergency-materials-form-select.component';
import { EmergencyMechanisationsFormSelectComponent } from './components/emergencies-list/emergency-mechanisations-form-select/emergency-mechanisations-form-select.component';
import { SignalDetailsComponent } from './components/modals/signal-details/signal-details.component';
import { EmergencyDetailsComponent } from './components/modals/emergency-details/emergency-details.component';
import { TrTotalsNewItemComponent } from './components/dashboard/trukov-total-newTems/tr-totals-new-Item.component';
import { NgApexchartsModule } from 'ng-apexcharts';
import { VIKTotalNewSignalsComponent } from './components/dashboard/vik-total-new-signals/vik-total-new-signals.component';
import { VIKtrTotalObrabotkaComponent } from './components/dashboard/vik-tr-total-obrabotka/vik-tr-total-obrabotka.component';
import { VIKTotalSignalsComponent } from './components/dashboard/vik-total-signals/vik-total-signals.component';
import { VIKTotalAvariiComponent } from './components/dashboard/vik-total-avarii-group/vik-total-avarii-group.component';
import { AvariiTypeEditComponent } from './components/nomenclatures/avarii-type/avarii-type-edit/avarii-type-edit.component';
import { TipAvariiCreationComponent } from './components/nomenclatures/avarii-type/avarii-type-creation/avarii-type-creation.component';
import { AvariiTypeComponent } from './components/nomenclatures/avarii-type/avarii-type.component';
import { TipAvariaClient } from '../../web-api-client';
import { SignalsMapListComponent } from './components/signals-registration-list/signal-map-list/signal-map-list.component';
import { SignalsMapListItemsComponent } from './components/signals-registration-list/signal-map-list/signal-map-list-items/signal-map-list-items.component';

@NgModule({
  declarations: [
    AddSignalRegistrationComponent,
    WorkingGroupComponent,
    WorkingGroupEditComponent,
    WorkingGroupsCreationComponent,
    SignalsRegistrationListComponent,
    UnitsComponent,
    UnitCreationComponent,
    UnitEditComponent,
    MaterialEditComponent,
    MaterialsCreationComponent,
    MaterialsComponent,
    SignalsMapViewComponent,
    EmergenciesListComponent,
    AddEmergencyComponent,
    EmergenciesMapViewComponent,
    SignalFilterFormComponent,
    MechanisationComponent,
    MechanisationCreationComponent,
    MechanisationEditComponent,
    EmergencyFilterFormComponent,
    EmergencyMaterialsFormSelectComponent,
    EmergencyMechanisationsFormSelectComponent,
    SignalDetailsComponent,
    EmergencyDetailsComponent,
    TrTotalsNewItemComponent,
    VIKTotalNewSignalsComponent,
    VIKtrTotalObrabotkaComponent,
    VIKTotalSignalsComponent,
    VIKTotalAvariiComponent,
    TipAvariiCreationComponent,
    AvariiTypeEditComponent,
    AvariiTypeComponent,
    SignalsMapListComponent,
    SignalsMapListItemsComponent

  ],
  exports: [
    TrTotalsNewItemComponent,
    VIKTotalNewSignalsComponent,
    VIKtrTotalObrabotkaComponent,
    VIKTotalSignalsComponent,
    SignalsRegistrationListComponent,
    VIKTotalAvariiComponent
  ],
  imports: [
    VikRoutingModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ToastrModule.forRoot(),
    AdminModule,
    SharedModule,
    NgApexchartsModule,
    NgxDropzoneModule,
    NgbModule,
    NgxIntlTelInputModule
  ],
  providers: [
    DatePipe
  ]
})
export class VikModule {
  static forRoot(): ModuleWithProviders<VikModule> {
    return {
      ngModule: VikModule,
      providers: [

      ],
    };
  }
}
